var QGIV = QGIV || {};

// flag for processing
QGIV.Account.processing = false;

// storage for heartbeat
QGIV.Account.heartbeat = null;

// method that performs AJAX call for heartbeat
QGIV.Account.checkPulse = function(callback, data){
    var data = data || null,
        callback = callback || function(){};

    $.fn.qpost({
        url : '/account/heartbeat/',
        data : data,
        csrf: false,
        success : function(response){
            callback.call(undefined, response);
        },
        failure : function(response){
            callback.call(undefined, response);
        }
    });
};

// method to start and store heartbeat
QGIV.Account.startHeartbeat = function(frequency){
    var _this = this,
        frequency = frequency || 60000,
        redirectURL = QGIV.Account.formatURL('/account/login/');

    // if heartbeat redirect is defined, set the redirect URL to that
    if ( typeof _this.heartbeatRedirect !== 'undefined' ) {
        // check if we should just reload the page
        if ( _this.heartbeatRedirect == 'reload' ) {
            redirectURL = window.location.href;
        } else {
            redirectURL = QGIV.Account.formatURL(_this.heartbeatRedirect);
        }
    }

    // refresh the session timestamp when we start heartbeat on page load
    if ( window.location.href.indexOf('login') < 0 && window.location.href.indexOf('create') < 0   && window.location.href.indexOf('reset') < 0) {
        _this.checkPulse(function(){}, { reload : 1 });
    }

    // setup heartbeat
    _this.heartbeat = setInterval(function(){
        // only run heartbeat if we're not on the login page
        if ( window.location.href.indexOf('login') < 0 && window.location.href.indexOf('create') < 0   && window.location.href.indexOf('reset') < 0) {
            _this.checkPulse(function(response){
                if ( response && response.success ) {

                } else {
                    window.location.href = redirectURL;
                }
            });
        }
    }, frequency);
};

// method to clear heartbeat for the account
QGIV.Account.stopHeartbeat = function(){
    clearInterval(this.heartbeat);
    this.heartbeat = null;
};

// method to grab transaction data using filters
QGIV.Account.getTransactions = function(filters){
    var defaultFilters = {
            start : $('.js-filter-start-date').val(),
            end : $('.js-filter-end-date').val(),
            page : $('.js-pagination-page.active').attr('data-page') || 1,
            numItems : $('.js-filter-per-page').val() || 10,
            scope : $('.js-filter-organization').val()
        },
        filters = filters || defaultFilters;

    // making sure we have an account ID before trying to get data
    if ( QGIV.Account.id ) {
        // AJAX call to login
        $.fn.qpost({
            url : url('account_dashboard' [QGIV.Account.id]),
            csrf: true,
            method : 'post',
            data : filters,
            success : function(result){
                if ( result && result.success && result.table ) {
                   $('.js-transaction-results').empty();
                   $('.js-transaction-results').append(result.table);

                   $('.js-transaction-total').empty().text(formatFormCurrency(result.total));
                } else if ( result.errors ) {
                    // report errors
                } else {
                    // report generic error
                }

                // trigger a resize when we have some kind of response
                Embed.resize();
            },
            failure : function(){
                // report generic error
            }
        });
    }
};

// method to format URL if we are embedding the account interface
QGIV.Account.formatURL = function(path){
    var path = path || '';

    // checking if we have embeds enabled
    if ( typeof QGIV.Embed !== 'undefined' && QGIV.Embed ) {
        // add a slash if the path doesn't end in one
        if ( path.substr(-1) !== '/' ) path += '/';

        // if we've gotten this far we know we at least need to add "embed"
        path += 'embed/';

        // check if there's a specific embed ID, if so add it
        // we can get this from accessing the EmbedChild object stored on QGIV.Embed
        if ( QGIV.Embed.settings.embed ) {
            path += QGIV.Embed.settings.embed + '/';
        }
    }

    return path;
};

// method to delete item related to the account
QGIV.Account.deleteObject = function(id, $scope, callback){
    var callback = callback || function(){},
        data = 'delete=';

    // prevent double processing
    if ( QGIV.Account.processing ) return false;
    QGIV.Account.processing = true;

    // make sure we have an item to delete
    if ( id ) {
        data += id;

        $.fn.qpost({
            type : 'post',
            dataType : 'json',
            data : data,
            success : function(response) {
                if ( response && response.success ) {
                    $scope.find('[data-id="' + id + '"]').fadeOut('fast', function() {
                        $scope.find('[data-id="' + id + '"]').remove();
                    });
                } else {
                    Message.target = $scope;
                    Message.post(response.errors, 'error');
                }

                QGIV.Account.processing = false;

                callback.call(undefined, response, id);
            }
        });
    }
};

QGIV.Account.renderAccountFrame = function(path) {
    var frame = document.createElement('iframe'),
        target = document.getElementById('qgiv-account-embed') || document.body;

    // build out frame attributes
    frame.setAttribute('id', 'qgiv-embed');
    frame.setAttribute('class', 'js-qgiv-account-embed');
    frame.setAttribute('frameborder', '0');
    frame.setAttribute('allowtransparency', 'true');
    frame.setAttribute('style', 'display: block; border: none; position: fixed; top: 0; right: 0; bottom: 0; left: 0; width: 100%; height: 100%; z-index: 99999999;');

    // if browser supports postMessage, remove scrolling
    if ( !!window.postMessage ){
        frame.setAttribute('scrolling', 'no');
    }

    // set the src
    frame.src = path;

    // append it to the DOM and focus on it
    target.appendChild(frame);
    frame.contentWindow.focus();
};

QGIV.Account.destroyAccountFrame = function(target) {
    var target = target || document.getElementById('qgiv-embed');

    target.parentNode.removeChild(target);
};

// placeholder for login success callback
QGIV.Account.onLoginSuccess = function(){};

// placeholder for login failure callback
QGIV.Account.onLoginFail = function(){};

// placeholder for new account creation success callback
QGIV.Account.onCreateAccountSuccess = function(){};

// placeholder for new account creation failure callback
QGIV.Account.onCreateAccountFail = function(){};

// pladeholder for logout callback
QGIV.Account.onLogout = function(){};

// pladeholder for social login callback
QGIV.Account.onSocialLogin = function(response){
    QGIV.Account.login(response);
};

// placeholder for additional login params (transaction ID, form ID, etc)
QGIV.Account.loginParams = [];

/* login
 * Handles logging into an account, response is handled with the `onLoginSuccess` callback
 * @param  data  {string}    Additional data you want passed to the login request
 * @returns {jQuery.jqXHR}
 */
QGIV.Account.login = function(data) {
    var _this = this,
        data = data || '';

    // if the data is an object/array, convert it to string
    if ( typeof data == 'object' ) {
        data = $.param(data);
    }

    // take the array of extra login data and turn them into a query string
    if ( QGIV.Account.loginParams.length ) {
        data += '&' + QGIV.Account.loginParams.join('&');
    }

    // On new standard form logins, pass the formKey with the data string
    if ( $('#form-template').length && $('#form-template').val().length && $('#form-template').val() === "8" ) {
        if ( $('#form-key').length && $('#form-key').val().length ) {
            data += '&formKey=' + $('#form-key').val();
        }
    }

    let url = "/account/login/";
    // -------------------------------------------------------------------------
    // NOTE: Standard P2P with the Redesigned Donation form use the new endpoint.
    // We also need to have the product type available. The isStandardP2P
    // evaluation will need to be removed once this Donation Form is used for
    // other products. We will also need to make the product type dynamic.
    // -------------------------------------------------------------------------
    const isStandardP2P =
        $("#form-template").length &&
        $("#form-template").val().length &&
        $("#form-template").val() === "10";

    const isStandardP2PRedesignedDonationForm =
        $("#donation-form-type").length &&
        $("#donation-form-type").val().length &&
        $("#donation-form-type").val() === "1";

    const isFundHub =
        $("#form-type").length &&
        $("#form-type").val().length &&
        $("#form-type").val() === "4";

    const theOneDonorAccountEndPoint = "/api/v1/donor/login/";

    if (isStandardP2P && isStandardP2PRedesignedDonationForm) {
        data += "&productType=3";
        data += `&form=${QGIV.Form.id}`;
        url = theOneDonorAccountEndPoint;
    }

    if(isFundHub) {
        url = theOneDonorAccountEndPoint;
    }

    // Need to filter out event aliases before checking for "create"
    var safePathname;
    var pathname = window.location.pathname;
    var eventPath = '/event/';
    var hasEventPath = pathname.startsWith(eventPath);
    if (hasEventPath) {
        var cleanPathname = "";
        // Checks whether or not there is a "/" after the event path
        var indexOfFirstCharAfterEventPath = pathname.indexOf('/', eventPath.length);
        // If there actually a path after the event
        if (indexOfFirstCharAfterEventPath !== -1 ) {
            // Get the cleanPathname starting at the first character after the slash
            cleanPathname = pathname.slice(indexOfFirstCharAfterEventPath + 1);
        }
        safePathname = cleanPathname;
    } else {
        safePathname = pathname;
    }

    if ( safePathname.indexOf('create') > -1 ) {
        url = '/account/create/';
    }

    return $.fn.qpost({
        url : url,
        type : 'post',
        dataType : 'json',
        data : data,
        success : function(response) {
            if ( response ) {
                QGIV.Account.onLoginSuccess.call(_this, response);
            }
        },
        failure : function(response) {
            QGIV.Account.onLoginFail.call(_this, response);
        }
    });
}

/* create account
 * Handles creating a new global account, response is handled with the `onCreateAccountSuccess` callback
 * @param  data  {string}    Additional data you want passed to the create account request
 */
QGIV.Account.createAccount = function(data) {
    var _this = this,
        data = data || '',
        $form = $('.js-create-account-form');

    // if the data is an object/array, convert it to string
    if ( typeof data == 'object' ) {
        data = $.param(data);
    }

    // take the array of extra login data and turn them into a query string
    if ( QGIV.Account.loginParams.length ) {
        data += '&' + QGIV.Account.loginParams.join('&');
    }

    // AJAX call to create account
    $.fn.qpost({
        url : '/account/create/',
        type : 'post',
        dataType : 'json',
        data : data,
        success : function(response) {
            if ( response ) {
                QGIV.Account.onLoginSuccess.call(_this, response);
            }
        },
        failure : function(response) {
            QGIV.Account.onLoginFail.call(_this, response);
        }
    });

}

/* Facebook authentication
 * recursive method to check for authenticated Facebook session
 * once we have one we can proceed to login
 * @param  response  {object}  Authentication response from Facebook
 */
QGIV.Account.facebookSignin = function(response) {
    var _this = this,
        response = response || null;

    // make sure FB is initialized first
    if (FB instanceof Object) {
        // if we don't have a response yet, it means we're not authenticated with FB yet
        if ( response !== null ) {
            // if our account has been "connected" with FB we can proceed to logging in using the user ID and token
            if ( response.status === 'connected' ) {
                var resp = response;

                FB.api('/me', { fields: 'name, first_name, last_name, email, permissions' }, function(response) {
                    var userId = resp.authResponse.userID,
                        token = resp.authResponse.accessToken,
                        email = response.email,
                        firstName = response.first_name,
                        lastName = response.last_name,
                        permissions = '';

                    if (response.permissions && response.permissions.data) {
                        permissions = JSON.stringify(response.permissions.data);
                    }

                    var data = {
                        fb_signin : 1,
                        userId : userId,
                        token : token,
                        email : email,
                        firstName : firstName,
                        lastName : lastName,
                        permissions : permissions,
                        success : true
                    };

                    //QGIV.Account.login(data);
                    QGIV.Account.onSocialLogin.call(_this, data);
                });
            }
            // if not, we need to prompt the user to connect their FB account
            else {
                FB.login(function(response) {
                    if ( response.status === 'connected' ) {
                        QGIV.Account.facebookSignin( response );
                    }
                }, { scope: 'public_profile,email' });

                // reset facebook button text to default
                $( '.js-facebook-login' ).each( function() {
                    var defaultText = $( '.js-facebook-login' ).attr( 'data-default-text' );
                    if ( defaultText ) {
                        $( '.js-facebook-login' ).html( defaultText )
                        $( '.js-facebook-login' ).removeAttr( 'data-default-text' );
                    }
                });
            }
        }
        // prompting the user to login with FB
        else {
            FB.getLoginStatus(function(response) {
                QGIV.Account.facebookSignin(response);
            });
        }
    }
};

// method for Google signin
QGIV.Account.googleSignin = function(googleUser) {
    var _this = this,
        profile = googleUser.getBasicProfile();

    var userId = profile.getId(),
        token = googleUser.getAuthResponse().id_token,
        name = profile.getName(),
        email = profile.getEmail();

    var data = {
        g_signin : 1,
        userId : userId,
        token : token,
        name : name,
        email : email,
        success : true
    };

    QGIV.Account.onSocialLogin.call(_this, data);
};

// method for Google signin
QGIV.Account.appleSignIn = function(token, user) {
    var _this = this,
    data = {
        a_signin : 1,
        token : token,
        success : true
    };

    if ( user && user.name ) {
        if ( user.name.firstName ) {
            data.firstName = user.name.firstName;
        }
        if ( user.name.lastName ) {
            data.lastName = user.name.lastName;
        }
    }

    QGIV.Account.onSocialLogin.call(_this, data);
};

QGIV.Account.logout = function(callback) {
    var _this = this,
        callback = callback || function(){};

    $.fn.qpost({
        url : '/account/login/',
        type : 'post',
        dataType : 'json',
        data : "logout=1",
        success : function(response) {
            callback.call(_this, response);
        }
    });
};


QGIV.Account.init = function(){
    // init facebook sdk
    UI.vendor.facebook(function(){
        // bind facebook login
        $('.js-facebook-login').on('click', function() {
            // change facebook button text to indicate loading
            var defaultText = $( this ).html(),
                submitText = $( this ).attr( 'data-submit-text' );
            $( this ).attr( 'data-default-text', defaultText );
            $( this ).html( submitText );

            QGIV.Account.facebookSignin();
        });
    }, '139246682755300');

    // bind google auth
    $('.g-signin2').on('click', function() {
        $(this).addClass('login-instantiated');
    });

    $('.js-apple-login').on('click', function() {
        QGIV.Account.initAppleLogin($(this).data('apple-state'));
    });
};

QGIV.Account.initAppleLogin = function(state) {
    //add apple listeners
    function onAppleSuccess(data) {
        //handle successful response
        var token = data.detail.authorization;
        var user = data && data.detail && data.detail.user ? data.detail.user : null;

        QGIV.Account.appleSignIn(token, user);

        document.removeEventListener('AppleIDSignInOnSuccess', onAppleSuccess);
        document.removeEventListener('AppleIDSignInOnFailure', onAppleFailure);
    }
    function onAppleFailure(error) {
        //handle error response
        message = { errors: ['An error has occurred. Please try again.'] };
        QGIV.Embed.send(message);

        document.removeEventListener('AppleIDSignInOnSuccess', onAppleSuccess);
        document.removeEventListener('AppleIDSignInOnFailure', onAppleFailure);
    }

    // attempt to remove any already set listeners to prevent double send
    try {
        document.removeEventListener('AppleIDSignInOnSuccess', onAppleSuccess);
        document.removeEventListener('AppleIDSignInOnFailure', onAppleFailure);
    }
    catch(err) { }

    document.addEventListener('AppleIDSignInOnSuccess', onAppleSuccess);
    document.addEventListener('AppleIDSignInOnFailure', onAppleFailure);
    var redirect = window.location.protocol+'//'+window.location.hostname+'/event/apple/';

    AppleID.auth.init({
        clientId : 'com.qgiv.secure',
        scope : 'name email',
        redirectURI : redirect,
        state : state,
        usePopup : true
    });

    AppleID.auth.signIn();
}

// callback function for `onsuccess` of Google auth
function onGoogleSignin(googleUser) {
    if ( $('.g-signin2').hasClass('login-instantiated') ) {
        QGIV.Account.googleSignin(googleUser);
    }
}
